import { PolicyRouteOption } from './policy';

// Display enrichment only. A partial or ambiguous catalog must never pick an arbitrary supplier.
export function providerNames(value: unknown): Map<string, string> {
  const page = value as { items?: unknown[]; count?: unknown } | undefined;
  if (
    !Array.isArray(page?.items) ||
    !Number.isSafeInteger(Number(page.count)) ||
    Number(page.count) !== page.items.length
  )
    return new Map();
  const names = new Map<string, Set<string>>();
  for (const item of page.items) {
    const row = item as { accessCode?: unknown; supplierName?: unknown } | null;
    if (typeof row?.accessCode !== 'string') continue;
    const set = names.get(row.accessCode) ?? new Set<string>();
    set.add(typeof row.supplierName === 'string' ? row.supplierName.trim() : '');
    names.set(row.accessCode, set);
  }
  return new Map(
    [...names].flatMap(([code, values]) => {
      const name = [...values][0];
      return values.size === 1 && name && name.length <= 200 ? [[code, name] as [string, string]] : [];
    }),
  );
}
export function providerLabel(route: PolicyRouteOption, names: Map<string, string>, unknown: string) {
  return `${names.get(route.access_code) ?? unknown} · ${route.display_name} · ${route.access_code}`;
}
